/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { Field, FieldProps } from 'formik';
import { FormTextField } from 'components/TextField';
import {
  AnnualIncomeField,
  IntendedPurchaseAmountField,
  LoyaltyNumberField,
} from 'components/form';

import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import { dateMask, dobPipe } from 'utils/masks';
import useTranslate from 'hooks/useTranslate';
import useFieldCustomization from 'hooks/useFieldCustomization';

import withOptional from './withOptional';
import { selectLockedFields } from 'state/creditApplication';

const storeNumberMask = createNumberMask({
  prefix: '',
  includeThousandsSeparator: false,
  allowLeadingZeroes: true,
});

const AdditionalFields: React.FC = () => {
  const lockedFields = useSelector(selectLockedFields);

  const t = useTranslate();
  const { isRequired, isVisible } = useFieldCustomization();

  return (
    <React.Fragment>
      {isVisible('emailAddress') && (
        <Grid item xs={12} sm={6}>
          <Field name="emailAddress">
            {(fieldProps: FieldProps) => (
              <FormTextField
                id="creditAppEmail"
                fieldProps={fieldProps}
                required={isRequired('emailAddress')}
                type="email"
                autoComplete="email"
                label={withOptional(
                  t('formLabel.emailAddress'),
                  isRequired('emailAddress'),
                )}
              />
            )}
          </Field>
        </Grid>
      )}

      <Grid item xs={12} sm={6}>
        <Field name="dateOfBirth">
          {(fieldProps: FieldProps) => (
            <FormTextField
              id="creditAppDOB"
              fieldProps={fieldProps}
              label={t('formLabel.dateOfBirth')}
              placeholder="mm/dd/yyyy"
              mask={dateMask}
              pipe={dobPipe}
              disabled={lockedFields.dateOfBirth}
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
              }}
            />
          )}
        </Field>
      </Grid>

      {isVisible('annualIncome') && (
        <Grid item xs={12} sm={6}>
          <AnnualIncomeField />
        </Grid>
      )}

      {isVisible('intendedPurchaseAmount') && (
        <Grid item xs={12} sm={6}>
          <IntendedPurchaseAmountField />
        </Grid>
      )}

      {isVisible('storeNumber') && (
        <Grid item xs={12} sm={6}>
          <Field name="storeNumber">
            {(fieldProps: FieldProps) => (
              <FormTextField
                id="creditAppStoreNumber"
                fieldProps={fieldProps}
                required={isRequired('storeNumber')}
                mask={storeNumberMask}
                label={withOptional(
                  t('formLabel.storeNumber'),
                  isRequired('storeNumber'),
                )}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                }}
              />
            )}
          </Field>
        </Grid>
      )}

      {isVisible('loyaltyNumber') && (
        <Grid item xs={12} sm={6}>
          <LoyaltyNumberField />
        </Grid>
      )}
    </React.Fragment>
  );
};

export default AdditionalFields;
